import styled from 'styled-components'

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`

export const QuestionContainer = styled.div`
  border: 1px solid var(--color-issabeline-grey);
  border-radius: 10px;
  margin-bottom: 20px;
`

export const QuestionHeader = styled(FlexContainer)`
  background-color: var(--color-selago-grey);
  padding: 12px 20px;
  justify-content: space-between;
`

export const QuestionNumber = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: var(--color-charcoal);
  margin: 0;
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;

  &:hover {
    opacity: 0.7;
  }
`

export const QuestionContent = styled.div`
  padding: 20px;
`

export const QuestionInputWrapper = styled.div`
  & > p {
    margin: 0;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    color: var(--color-text-form-label);
  }
`

export const QuestionTypeWrapper = styled.div`
  width: 216px;
  height: 38px;
  margin: 0 15px 0 5px;
`

export const RequiredCheckboxWrapper = styled(FlexContainer)`
  padding-bottom: 0;
  height: 38px;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid rgba(226, 232, 234, 1);
  padding: 7px 12px;
  margin-right: 12px;

  /* Override the default checkbox styles */
  & > div {
    margin: 0 !important;
  }
`

// Multiple Choice Options Styling
export const OptionsContainer = styled.div`
  margin-top: 20px;
`

export const OptionsHeader = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-form-label);
  margin-bottom: 12px;
`

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  position: relative;
`

export const OptionNumber = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-form-label);
  width: 30px;
`

export const OptionInputWrapper = styled.div`
  width: 90%;
  margin-right: 10px;
`

export const DeleteOptionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AddOptionButton = styled.button`
  background: none;
  border: 1px solid var(--color-button-primary);
  color: var(--color-button-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
`

export const CorrectAnswerContainer = styled.div`
  margin-top: 20px;
  width: 362px;
  margin-right: 15px;
`

export const CorrectAnswerHeader = styled(OptionsHeader)`
  margin-bottom: 8px;
`

export const CorrectAnswerSelect = styled.div`
  width: 100%;
`
export const ValidationError = styled.p`
  color: var(--color-text-error)!important;
  font-size: 12px!important;
  font-weight: 500!important;
  line-height: 14px!important;
  margin-top: 2px!important;
  margin-bottom: 0px!important;
`